import { COMMON_WAIFUS, getCommonReviews } from '../../../constants.js';

export const RU_BASE = {
    hero: {
      title: "Waifu Briscola",
      tagline: "Брискола, какой вы её ещё не видели: RPG, Waifu и ИИ.",
      ctaWeb: "Играть в браузере",
      ctaAndroid: "Скачать на Android",
      version: "Версия 2.3",
      badge: "✨ Новый режим Подземелья"
    },
    stats: {
      downloads: "Загрузки",
      downloadsValue: ["Не сосчитать!", "Серверы переполнены", "Куча!", "Более 9000", "Слишком много"],
      hands: "Проигранные раздачи",
      handsValue: ["Слишком много...", "Не хватает скилла", "Виноват лаг", "Все еще плачу", "Попробуй снова, повезет"],
      rating: "Оценка",
      ratingValue: ["Бабушка одобряет", "11/10 - IGN", "Лучше, чем пицца", "GOTY 2026", "Абсолютный шедевр"],
      waifus: "Вайфу",
      waifusValue: ["Все для тебя", "Только 2D > 3D", "Собери их всех!", "Вайфу > Мета", "Настоящее сокровище"]
    },
    features: {
      title: "Гораздо больше, чем карточная игра",
      items: [
        { id: "classic", title: "Классическая Брискола", description: "Оригинальный опыт, идеальный и чистый.", icon: "🃏" },
        { id: "roguelike", title: "RPG Рогалик", description: "Взбирайтесь на башню, получайте силы стихий и побеждайте боссов.", icon: "⚔️" },
        { id: "ai", title: "Живой ИИ", description: "Благодаря Google Gemini, противники оскорбляют или хвалят вас в реальном времени.", icon: "🧠" },
        { id: "gacha", title: "Гача Система", description: "Используйте монеты для разблокировки новых скинов и редких фонов.", icon: "💎" },
        { id: "dungeon", title: "Режим Подземелья", description: "Сражайтесь с боссами с безумными правилами. Одно поражение — и конец.", icon: "🏰" },
        { id: "puzzle", title: "Режим Головоломки", description: "Решайте сложные сценарии с конкретными целями.", icon: "🧩" }
      ]
    },
    video: { title: "Геймплей Трейлер" },
    waifus: {
      title: "Выберите свою Спутницу",
      subtitle: "У каждого персонажа уникальный характер, озвучка и стиль игры.",
      characters: [
        { ...COMMON_WAIFUS[0], name: "Miu", role: "Милашка", personality: "Милая и солнечная, любит быть рядом." },
        { ...COMMON_WAIFUS[1], name: "Rei", role: "Аналитик", personality: "Расчетливая и холодная. Только логика." },
        { ...COMMON_WAIFUS[2], name: "Akame", role: "Цундере", personality: "Соревновательная и вспыльчивая. Ненавидит проигрывать." },
        { ...COMMON_WAIFUS[3], name: "Lilith", role: "Королева", personality: "Темная королева карт." },
        { ...COMMON_WAIFUS[4], name: "Mochi", role: "Проводник", personality: "Ваш верный проводник... возможно." }
      ]
    },
    reviews: {
      title: "Говорят о нас (к сожалению)",
      items: getCommonReviews('ru')
    },
    ctaStrip: {
      title: "Готовы выйти на поле?",
      subtitle: "Присоединяйтесь к другим игрокам и начните свое приключение сегодня.",
      button: "Начать Играть Сейчас"
    },
    footer: { privacy: "Конфиденциальность", terms: "Условия", copyright: "© 2026 Waifu Briscola" },
    privacy: {
      title: "Политика конфиденциальности Waifu Briscola",
      lastUpdated: "Последнее обновление: 25 мая 2024",
      intro: "Эта Политика конфиденциальности описывает, как обрабатывается ваша информация при использовании приложения Waifu Briscola ('Сервис').",
      sections: [
        {
          title: "Информация, которую мы собираем",
          intro: "Для улучшения вашего опыта мы используем сторонние сервисы, которые могут собирать информацию:",
          items: [
            "Данные об использовании (PostHog): Мы собираем анонимные или псевдонимные аналитические данные о том, как вы взаимодействуете с игрой. Это включает такие события, как начало игры, сыгранные карты и конечные результаты. Эти данные помогают нам понять, как используется игра, и как мы можем её улучшить. Мы не собираем личную идентификационную информацию (PII) через PostHog.",
            "Взаимодействие с ИИ (Google Gemini): Сообщения чата, которые вы отправляете, и информация о состоянии игры (например, карты в вашей руке и на столе) отправляются в API Google Gemini для генерации ответов и ходов ИИ. Эти взаимодействия регулируются Политикой конфиденциальности Google. Мы не отправляем никакую личную информацию в Google, кроме содержания ваших игровых взаимодействий.",
          ],
        },
        {
          title: "Как мы используем вашу информацию",
          intro: "Мы используем собранную информацию для:",
          items: [
            "Предоставления, эксплуатации и поддержки нашего Сервиса.",
            "Улучшения, персонализации и расширения нашего Сервиса.",
            "Понимания и анализа того, как вы используете наш Сервис.",
            "Предотвращения злоупотреблений и обеспечения безопасности.",
          ],
        },
        {
          title: "Обмен информацией",
          body: "Мы не передаем вашу личную информацию никому, кроме сторонних поставщиков услуг (PostHog, Google), необходимых для работы приложения, как описано выше.",
        },
        {
          title: "Безопасность данных",
          body: "Безопасность вашей информации важна для нас, но помните, что ни один метод передачи через Интернет или метод электронного хранения не является безопасным на 100%.",
        },
        {
          title: "Изменения в этой Политике конфиденциальности",
          body: "Мы можем время от времени обновлять нашу Политику конфиденциальности. Мы сообщим вам о любых изменениях, опубликовав новую Политику конфиденциальности на этой странице.",
        },
        {
          title: "Свяжитесь с нами",
          body: "Если у вас есть вопросы об этой Политике конфиденциальности, вы можете связаться с ответственным лицом Мауро Маццоккетти.",
        },
      ],
    },
    consent: { text: "Мы используем cookie и аналитику для улучшения сайта. Продолжая, вы принимаете нашу", ok: "Понятно" },
    terms: {
      title: "Условия использования Waifu Briscola",
      lastUpdated: "Последнее обновление: 25 мая 2024",
      contact: "Ответственное лицо: Мауро Маццоккетти",
      intro: "Добро пожаловать в Waifu Briscola! Эти условия описывают правила использования приложения Waifu Briscola ('Сервис').",
      sections: [
        {
          title: "Принятие Условий",
          body: "Получая доступ и используя этот Сервис, вы соглашаетесь соблюдать эти Условия. Если вы не согласны с какой-либо частью условий, вы не можете использовать Сервис.",
        },
        {
          title: "Использование Сервиса",
          body: "Вы соглашаетесь не использовать Сервис в незаконных или несанкционированных целях. Вы несете ответственность за свое поведение и любой контент, который вы предоставляете при использовании Сервиса, включая сообщения чата.",
        },
        {
          title: "Контент, созданный ИИ",
          intro: "Сервис использует модели искусственного интеллекта (Google Gemini) для генерации ответов, комментариев и игровых ходов. Вы признаете, что:",
          items: [
            "Контент, созданный ИИ, производится моделью и не всегда может быть точным, уместным или последовательным.",
            "Мы не несем ответственности за контент, созданный ИИ.",
            "Взаимодействия с ИИ предназначены только для развлекательных целей.",
          ],
        },
        {
          title: "Ограничение ответственности",
          body: "Ни в коем случае Мауро Маццоккетти или его партнеры не несут ответственности за любые косвенные, случайные, особые, последующие или штрафные убытки, включая, без ограничений, потерю прибыли, данных, репутации или другие нематериальные потери, возникшие в результате (i) вашего доступа или использования или невозможности доступа или использования Сервиса; (ii) любого контента, полученного от Сервиса.",
        },
        {
          title: "Изменения в Условиях",
          body: "Мы оставляем за собой право по своему усмотрению изменять или заменять эти Условия в любое время. Мы сообщим вам о любых изменениях, опубликовав новые условия на этой странице.",
        },
        {
          title: "Применимое право",
          body: "Эти Условия регулируются и толкуются в соответствии с законами Италии без учета положений коллизионного права.",
        },
      ],
    }
};
